import { render } from "./DurationField.vue?vue&type=template&id=737ae2d8"
import script from "./DurationField.vue?vue&type=script&lang=js"
export * from "./DurationField.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__